// extracted by mini-css-extract-plugin
export var fadeIn = "_ji-1";
export var modalContent = "_ji-3";
export var overlay = "_ji-0";
export var popoverContent = "_ji-2";
export var results = "_ji-5";
export var searchInputWrapper = "_ji-4";